import { render, staticRenderFns } from "./PubForm.vue?vue&type=template&id=39027b9e&scoped=true&"
import script from "./PubForm.vue?vue&type=script&lang=js&"
export * from "./PubForm.vue?vue&type=script&lang=js&"
import style0 from "./PubForm.vue?vue&type=style&index=0&id=39027b9e&lang=scss&scoped=true&"
import style1 from "./PubForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39027b9e",
  null
  
)

export default component.exports